import React from "react";

const BlogCardSkeleton = ({ count }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <div className="col-xl-4 col-lg-6 col-md-6" key={i}>
          <div className="blog-maincard skeleton-card">
            <div className="blog-cardimgDiv skeleton-img"></div>
            <div className="blogcard-content">
              <div className="skeleton-category skeleton-line"></div>
              <div className="skeleton-title skeleton-line"></div>
              <div className="skeleton-desc skeleton-line short"></div>
              <div className="skeleton-desc skeleton-line medium"></div>
              <div className="skeleton-desc skeleton-line long"></div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default BlogCardSkeleton;
